import {Component, OnInit, ViewChild} from "@angular/core";
import {UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl} from "@angular/forms";
import { Observable, throwError } from 'rxjs';
import {LogService} from "../Abstract/log.service";
import {ConfigService} from "../../Core/Abstract/config.service";
import {EventsEmitterService} from "../../Core/Abstract/emitter.service";
import {PasswordValidatorOptions, passwordValidator} from "../Login/passwordValidator.component";
import {matchOtherValidator} from "../Login//matchOtherValidator.component";
import {ForgotPasswordService} from "./forgotPassword.service";
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'forgotPassword',
    templateUrl: 'forgotPassword.component.html',
    providers: [ForgotPasswordService]
})

export class ForgotPasswordComponent implements OnInit {


    @ViewChild('msgModal',{static: false}) public msgModal: ModalDirective;
    /*
     *  Modal handling
     */

    public showChildModal(): void {
        this.msgModal.show();
    }

    public hideChildModal(): void {
        this.msgModal.hide();
    }


    protected redirectTitle = "";
    protected redirectMsg = "";

    private loading: boolean = false;
    private regexList:Array<PasswordValidatorOptions> = [];
    private rulesArray:Array<Object> = [];

    
    private pwdForm: UntypedFormGroup;
    private pwdmodel:any;    
    private validationMessages= {};
    private formErrors = {
        'email': '',
        'username': ''
    };

    pwderror = false;
    pwdmsg = "";
    public barLabel: string = "";

    constructor(private forgotPasswordService: ForgotPasswordService, private logger: LogService, private fb: UntypedFormBuilder,
                private configService: ConfigService, private eventsEmitterService :EventsEmitterService) {

        this.pwdmodel = {'username': ''};  
    }

    ngOnInit(): void {
       this.buildForm();
    }

    private buildForm() {

        this.pwdForm = new UntypedFormGroup({
            'username': new UntypedFormControl(this.pwdmodel.username, [Validators.required , Validators.email])
        });

        this.validationMessages = {
            'username': {
                'required': 'Required field',
                'email': 'Invalid email value'
            },
        };

        this.pwdForm.valueChanges.subscribe(data => this.onValueChanged(data));

        this.onValueChanged();
    }

    onValueChanged(data?: any) {
        if (!this.pwdForm) { return; }

        const form = this.pwdForm;
        //this.logger.log(this.pwdForm);
        for (const field in this.formErrors) {
            // clear previous error message (if any)
            this.formErrors[field] = [];
            const control = form.get(field);

            if (control && control.dirty && !control.valid) {
                const messages = this.validationMessages[field];
                //this.logger.log(control.errors)
                for (const key in control.errors) {
                    this.formErrors[field].push(messages[key]);
                }
            }
        }
        
        // this.logger.log("formerrors: " + JSON.stringify(this.formErrors));
    }

    public returnToLogin(){
        this.forgotPasswordService.goToLogin();
    }

    public doForgotPassword(pwdmodel){
        this.loading = true;
        this.pwderror = false;

        //mock
        // this.loading = false;

        // this.redirectTitle = 'ForgotPassworded Successfully';
        // this.redirectMsg = 'A verification email has been sent. Please verify your account to enable login.';
        // this.showChildModal();

        // real
        
        this.forgotPasswordService.forgotPasswordRequest(pwdmodel).subscribe(
            data => {
                this.logger.log(data);
                this.loading = false;
                this.showChildModal();
            },
            error => {
                this.loading = false;
                this.pwderror = true;
                this.pwdmsg = error.message;

                this.logger.error(error);
                return throwError(error);
            }
            
        );
        
    }
}